import promo from "../newcomponents/customerComponents/Promotion";

export function clearCustomerBenefits({ customer, pm, cart, finalOrder }, actions) {
    const customerPromotionIds = new Set(((customer && customer.promotion) || []).map((p) => p._id).filter(Boolean));
    const promotions = (pm || []).filter((p) => !p.isMemberOnly && !p.customerRewardId && !customerPromotionIds.has(p._id));
    let items = JSON.parse(JSON.stringify(cart || [])).filter((item) => !item.autoAddedReward);
    items.forEach((item) => {
        item.hasSpecialDiscount = false;
        item.specialDiscount = 0;
        item.specialDiscountAmount = 0;
        item.specialDiscountRemark = "";
    });
    items = promo.applyPromotion(promotions, promo.clearPromotion(items));
    localStorage.removeItem("customer");
    localStorage.setItem("promotion", JSON.stringify(promotions));
    localStorage.setItem("order", JSON.stringify(items));
    actions.addCustomer("");
    actions.addPromotion(promotions);
    actions.addToCart(items);
    actions.setRedeem([]);
    actions.setDiscount(null);
    const savedOrder = finalOrder || JSON.parse(localStorage.getItem("finalOrder"));
    if (savedOrder) {
        const order = { ...savedOrder, customer: "", data: items, redeem: [], discount: null };
        actions.setFinalOrder(order);
        localStorage.setItem("finalOrder", JSON.stringify(order));
    }
}
